import React, { Fragment } from 'react'
import FloatingContainer from '../../components/global/floatingContainer'
import SignInFields from './signInFields'
import Introduction2 from '../../components/global/introduction2'

const SignIn = () => {
    return (
        <Fragment>
            <Introduction2
                children={
                    <FloatingContainer
                        children={
                            <SignInFields />
                        }
                    />
                }
            />
        </Fragment>
    )
}

export default SignIn